const PaymentRoutes = {
  getPaymentMethodStatus: "/paymentMethod/getPaymentStatus",
  updatePaymentMethodStatus: "/paymentMethod/updatePaymentMethodStatus",
  getEscrowAccountLedger: "/paymentMethod/getescrowAccountLedger"
}

export default PaymentRoutes;